import styled from "@emotion/styled";
import { colors } from "styles/colors";
import { fonts } from "styles/fonts";

export const Title = styled.div`
  margin: 0;
  padding: 11px 9px 8px 0;
  letter-spacing: 0.15px;

  @media (min-width: 769px) {
    font-family: ${fonts.latoBold};
    color: ${colors.GREY_DARK};
    padding: 11px 9px 8px 0;
  }
`;

export const TitleDropdown = styled.div`
  margin: 0;
  padding: 11px 9px 8px 0;
  letter-spacing: 0.15px;
  cursor: pointer;

  ${(props) =>
    props.show
      ? `
    .icon {
      margin: 0 0 0px 4px;
      transform: rotate(180deg);
    }
  `
      : `
    .icon {
      margin: 0 0 -8px 10px;
    }
  `}

  @media (min-width: 769px) {
    font-family: ${fonts.latoBold};
    color: ${colors.GREY_DARK};
    padding: 11px 9px 8px 0;
  }
`;

export const LinkWrap = styled.a`
  //width: 80%;
`;

export const Links = styled.ul`
  padding: 0;
  margin: 0;
  list-style-type: none;

  &:last-child {
    margin-bottom: 0;
  }

  > li {
    @media (min-width: 769px) {
      margin-left: -11px;
    }
  }
`;

export const LinksWrap = styled.div`
  ${(props) =>
    props.isDropDown
      ? `      
        display: block;           
    `
      : `   
        display: none;   
    `}
`;

export const LinkItem = styled.li`
  ${LinkWrap} {
    display: inline-flex;
    align-items: center;
    cursor: pointer;
    padding: 7px 12px 6px 11px;
    text-decoration: none;
    color: inherit;
    border-radius: 5px;
    transition: background-color, color 0.3s ease-in-out;

    @media (min-width: 769px) {
      display: flex;
      justify-content: row;
      align-items: center;
      padding: 7px 12px 6px 11px;
    }
  }
  &:not(.isActive) {
    a:hover {
      color: ${colors.RED};
      .icon {
        stroke: ${colors.RED};
        fill: ${colors.RED};
      }
    }
  }
  .icon,
  img {
    display: inline-block;
    vertical-align: top;
    margin-right: 14px;
    transition: all 0.3s ease-in-out;
    stroke: ${colors.WHITE};
    fill: ${colors.WHITE};
    margin-left: -11px;
    @media (min-width: 769px) {
      margin-right: 11px;
      margin-left: 0;
      margin-top: 0;
      stroke: ${colors.GREY_SEMIDARK};
      fill: ${colors.GREY_SEMIDARK};
    }
  }

  /* LinkItem isActive */
  @media (min-width: 769px) {
    &.isActive {
      ${LinkWrap} {
        background-color: ${colors.GREY_LIGHT};
      }
    }
  }
`;

/* DropDown */

export const DropDownToggle = styled.div`
  color: ${colors.WHITE};
  position: relative;
  cursor: pointer;
  width: auto;
  display: flex;

  .icon,
  img {
    display: inline-block;
    vertical-align: top;
    height: 36px;
    width: 36px;
    outline: none;
    stroke: ${colors.GREY_SEMIDARK} !important;
    border-radius: 50%;
    background-color: ${colors.GREY_SEMILIGHT};
    transition: all 0.3s ease-in-out;
    max-width: none;
    object-fit: cover;
    object-position: center;
  }

  @media (min-width: 769px) {
    color: ${colors.GREY_DARK};
    padding: 9px 22px 7px 0;
    display: inline-block;
    font-family: ${fonts.latoBold};
  }

  &::after {
    ${(props) => (props.isArrow ? `` : `content: "";`)}
    align-self: center;
    width: 0;
    height: 0;
    border-style: solid;
    ${(props) =>
      props.isDropDown
        ? `
      border-width: 0 5px 5px 5px;
      border-color: transparent transparent ${colors.WHITE} transparent;
      @media (min-width: 769px) {
        border-color: transparent transparent ${colors.GREY_DARK} transparent;    
      }
    `
        : `
      border-width: 5px 5px 0 5px;
      border-color: ${colors.WHITE} transparent transparent transparent;
      @media (min-width: 769px) {
        border-color: ${colors.GREY_DARK} transparent transparent transparent;      
      }
    `}
  }
`;
export const DropDown = styled.div`
  ${LinkWrap} {
    padding: 4px 12px 5px 0;
  }
`;
/* AddRecipe */
export const AddRecipe = styled.a`
  text-decoration: none;
  cursor: pointer;
  padding: 4px 11px;
  display: inline-block;
  color: ${colors.RED};
`;
/* BtnBlock */
export const BtnBlock = styled.div`
  margin-top: auto;
  > * {
    width: 100%;
  }
  > * + * {
    margin-top: 20px;
  }
  @media (min-width: 769px) {
    display: none;
    visibility: hidden;
  }
`;

export const MenuWraper = styled.div`
  width: 0;
  ${({ isSelebrity }) => isSelebrity && `margin-top: 50px;`}
  @media (min-width: 1024px) {
    width: 220px;
    ${(props) => props.hideDesktop && "display: none;"}
  }
`;

export const MenuMain = styled.div`
  height: 100%;
  overflow: auto;
  background-color: ${colors.GREY_DARK};
  color: ${colors.WHITE};
  display: none;

  @media (min-width: 1024px) {
    position: sticky;
    top: 125px;
    left: 15px;
    display: block;
    height: auto;
    flex: 1 0 217px;
    padding-left: 15px;
    padding-right: 15px;
    margin-top: 5px;
    color: ${colors.GREY_SEMIDARK};
    background-color: transparent;
  }
`;

/* BtnBlock */
export const DropDownWrap = styled.div`
  @media (max-width: 768px) {
    ${DropDown}:first-of-type {
      border-top: 2px solid ${colors.GREY_SEMIDARK};
    }
    ${DropDown} {
      border-bottom: 2px solid ${colors.GREY_SEMIDARK};
    }
    > div:first-of-type {
      border-top: 2px solid ${colors.GREY_SEMIDARK};
    }
  }
`;
export const ButtonsDesktop = styled.div`
  display: none;
  @media (min-width: 769px) {
    display: block;
  }
`;

export const Wrapper = styled.div`
  border-bottom: 2px solid ${colors.GREY_SEMIDARK};
  padding-bottom: ${(props) => (props.open ? "27px" : "35px")};
  margin-bottom: 27px;
`;
export const HomeWrapper = styled.div`
  border-bottom: 2px solid ${colors.GREY_SEMIDARK};
  padding-bottom: 27px;
  margin-bottom: ${(props) => (props.isBuyer ? "0" : "27px")};
`;

export const ManagerWrapper = styled.div`
  border-bottom: 2px solid ${colors.GREY_SEMIDARK};
  padding-bottom: 27px;
`;
